import {MessageErrorDetails} from '../../messages/entities/message-error-details.model';

export const STEP_SUBMIT_GENERIC_ERROR: MessageErrorDetails = {
  errorMessage: 'Unable to submit this step',
  errorDescription: 'Something went wrong. Please try again or contact support if the problem persists.'
};
